<template>
    <UModal :model-value="open" @update:model-value="$emit('update:open', $event)">
        <UCard :ui="{ rounded: 'rounded-lg', body: { base: 'overflow-visible' } }">
            <template #header>
                <div class="flex items-center justify-between">
                    <h3 class="text-base font-medium leading-6 text-gray-800">Edit Medical History</h3>
                    <UButton color="gray" variant="ghost" icon="i-ph-x-bold" class="-my-1" @click="dismiss()" />
                </div>
            </template>
            <div class="space-y-4">
                <UFormGroup label="Chronic Diseases">
                    <UTextarea v-model="data.chronic_diseases" size="xl" />
                </UFormGroup>
                <UFormGroup label="Chronic Medication">
                    <UTextarea v-model="data.chronic_medication" size="xl" />
                </UFormGroup>
                <UFormGroup label="Surgeries">
                    <UTextarea v-model="data.surgeries" size="xl" />
                </UFormGroup>
                <UFormGroup label="Allergies">
                    <UTextarea v-model="data.allergies" size="xl" />
                </UFormGroup>
            </div>
            <template #footer>
                <div class="flex items-center justify-end space-x-2">
                    <UButton @click="dismiss()" size="lg" color="white"> Cancel </UButton>
                    <UButton @click="confirm()" size="lg" color="black"> Save </UButton>
                </div>
            </template>
        </UCard>
    </UModal>
</template>

<script setup lang="ts">
import type { Customer } from '~/types/customer'

const emit = defineEmits<{
    'update:open': [boolean]
    'reload': [void]
}>()

const props = defineProps<{
    open: boolean
    customer?: Customer
}>()

const client = useSupabaseClient()
const toast = useToast()

const confirming = ref<boolean>(false)

const data = reactive({
    chronic_diseases: '',
    chronic_medication: '',
    surgeries: '',
    allergies: '',
})

watch(() => props.open, (open) => {
    if (open) {
        data.chronic_diseases = props.customer?.chronic_diseases || ''
        data.chronic_medication = props.customer?.chronic_medication || ''
        data.surgeries = props.customer?.surgeries || ''
        data.allergies = props.customer?.allergies || ''
    }
})

async function confirm() {
    if (props.customer?.id) {
        confirming.value = true

        const { error } = await client.from('customers')
            .update({
                chronic_diseases: data.chronic_diseases,
                chronic_medication: data.chronic_medication,
                surgeries: data.surgeries,
                allergies: data.allergies,
            } as never)
            .eq('id', props.customer.id)

        if (!error) {
            toast.add({
                title: 'Customer medical history updated!',
                color: 'green',
                icon: 'i-ph-check-circle-duotone'
            })

            emit('reload')
            dismiss()
        }
    }
}

function dismiss() {
    emit('update:open', false)
}
</script>
